import { CSSProperties } from 'react';

export const TankIcon = ({ style }: { style?: CSSProperties }) => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='24'
      height='24'
      viewBox='0 0 24 24'
      fill='currentColor'
      style={style}
    >
      <path d='M14.7461 17.7842H9.74609V19.584H7.94629V17.7842H7.40527C4.42017 17.7841 2.00026 15.364 2 12.3789C2.00007 9.39369 4.42006 6.97273 7.40527 6.97266H16.5947L16.873 6.98047C19.7289 7.12539 21.9999 9.48704 22 12.3789C21.9997 15.2706 19.7288 17.6324 16.873 17.7773L16.5947 17.7842H16.5459V19.584H14.7461V17.7842ZM7.40527 8.47363C5.24848 8.4737 3.50007 10.2221 3.5 12.3789C3.50026 14.5355 5.2486 16.2841 7.40527 16.2842H16.5947C18.7514 16.2841 20.4997 14.5355 20.5 12.3789C20.4999 10.2221 18.7515 8.4737 16.5947 8.47363H7.40527Z' />
      <path d='M14.7861 4.00586C15.3312 4.06119 15.7567 4.52126 15.7568 5.08097V6.43243H9V5.08097C9.00001 4.48397 9.48401 4.00001 10.081 4H14.6757L14.7861 4.00586Z' />
      <path d='M17.75 13.0002C17.75 13.4145 17.4142 13.7502 17 13.7502C16.5858 13.7502 16.25 13.4145 16.25 13.0002V11.0002C16.25 10.586 16.5858 10.2502 17 10.2502C17.4142 10.2502 17.75 10.586 17.75 11.0002V13.0002Z' />
    </svg>
  );
};
